// import {s360ConfigService} from "./Simplify360Chat/Services/S360Config";

import { s360ConfigService } from "./S360Config";
import HWUser from "../HWLibrary/HWUser";

const watchForChatSDKEvents = (appComponent, onDateRefresh, onConfigUpdate) => {
  
  window.addEventListener('message',
    messageEvent => {
     
      // console.log(messageEvent);
      if (!s360ConfigService.isClientHostConfigured() || messageEvent.origin !== s360ConfigService.sourceOrigin) return;
      // console.log("watchForChatSDKEvents",messageEvent.data);

      try {
        let messageData = JSON.parse(messageEvent.data);
        if (!messageData || messageData.clientHostId !== s360ConfigService.clientHostId || !messageData.action) { return; }
        // console.log("Data: ");
        // console.log(messageData);
        switch (messageData.action) {
          case "on-config-data-update": s360ConfigService.setConfig(messageData.data); onConfigUpdate(); break;
          case "on-reset-user":  onResetUser(onDateRefresh); break;
          case "on-set-user-config": s360ConfigService.setUserConfig(messageData.data); break;
          case "on-coach-screen":coachScreenOpen();break;
          case "on-coach-screen-close":coachScreenClose();break;
          default: break;
        }
      } catch (error) { console.log("Invalid Message Data: "); }

      appComponent.setState({ refreshKey: new Date().toISOString() });
    },
    false
  );
};

const onResetUser = (onDateRefresh) => {
  HWUser.resetUser();
  onDateRefresh && onDateRefresh();
  window.location.reload();
} 

const postPlatformMessage = (messageData, actionName) => {
  // console.log("messageData",messageData,actionName,s360ConfigService.clientHostId)
  if(!s360ConfigService.isClientHostConfigured() || !s360ConfigService.sourceOrigin) {
     
     return; }
  let message = { data: messageData, action: actionName , clientHostId: s360ConfigService.clientHostId };
  // try { window.parent.postMessage(JSON.stringify(message), s360ConfigService.sourceOrigin); } catch (error) { console.log(error); }
};

const fetchConfigDetailsFromClientHost = () => {
  postPlatformMessage(null, 'update-client-host-config');
};

const sendOnAppOpen = () => {

  postPlatformMessage(null, 'on-app-open');
};

const sendOnAppClose = () => {
  postPlatformMessage(null, 'on-app-close');
};
const coachScreenOpen = () => {
  postPlatformMessage(null, 'on-coach-screen');
}

const coachScreenClose =()=>{
  postPlatformMessage(null, 'on-coach-screen-close');
}
export { watchForChatSDKEvents, fetchConfigDetailsFromClientHost, sendOnAppOpen, sendOnAppClose,coachScreenOpen,coachScreenClose };
